import script from "./VoiceMessageButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./VoiceMessageButton.vue?vue&type=script&lang=ts&setup=true"

import "./VoiceMessageButton.vue?vue&type=style&index=0&id=069c7a7c&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-069c7a7c"]])

export default __exports__